// extracted by mini-css-extract-plugin
export default {"card":"ClinicInfo_card__7OjUA","grid4":"ClinicInfo_grid4__VW3nw","col":"ClinicInfo_col__x59PW","items":"ClinicInfo_items__gQKua"};